<template>
    <div>
        <!-- with-pagination -->
        <div :class="[ responsive ? 'table-responsive' : '', 'with-pagination'] ">
            <!-- table-style1 table-hover table-striped table-style2 -->
            <table class="table" :class="init_table_class" :style="(with_action_bar && noOfRecords > 0 && noOfRecords < 3 ? 'min-height:300px;' : '') + init_table_style">
                <thead :class="thead_class">
                <slot name="thead" :sort="sort" :locale="locale" :row_checkbox="row_checkbox" :clickCheckBox="clickCheckBox" :select_all="select_all"  :table_data="table_data"/>
                </thead>

                <tbody :class="tbody_class">
                <slot :table_data="table_data" :meta="meta" :row_checkbox="row_checkbox" :hasRecords="hasRecords" :clickCheckBox="clickCheckBox" />
                </tbody>
            </table>
        </div>
        <!-- with-pagination -->
        <nav class="table-pagination">
            <span class="current-page">{{ showing }}</span>
            <div class="navigate" v-if="hasPage">

                <a href="#" class="btn-page" @click.stop.prevent="first" v-if="meta.current_page != 1">
                    <i class="fas fa-step-backward" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page disabled" v-else>
                    <i class="fas fa-step-backward" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page disabled" v-if="onFirstPage">
                    <i class="fas fa-play fa-flip-horizontal" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page" @click="previous" rel="prev" v-else>
                    <i class="fas fa-play fa-flip-horizontal" aria-hidden="true"></i>
                </a>
                {{ trans[locale].page }}
                <div class="dropdown">
                    <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">{{ meta.current_page }}
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" :class="[ i == meta.current_page ? 'active' : '']"
                           v-for="i in meta.last_page" @click="changePage(i)">{{ i }}</a>
                    </div>
                </div>
                <a href="#" class="btn-page" @click.stop.prevent="next" v-if="meta.hasMorePage" rel="next">
                    <i class="fas fa-play" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page disabled" v-else rel="next">
                    <i class="fas fa-play" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page" v-if="meta.current_page != meta.last_page" @click.stop.prevent="last">
                    <i class="fas fa-step-forward" aria-hidden="true"></i>
                </a>
                <a href="#" class="btn-page disabled" v-else>
                    <i class="fas fa-step-forward" aria-hidden="true"></i>
                </a>

                <div class="no-of-items">
                    {{ trans[locale].display }}
                    <div class="dropdown">
                        <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">{{ meta.per_page }}
                        </button>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" :class="[ i == meta.per_page ? 'active' : '']"
                               v-for="i in [10,20,50,100]" @click="changePerPage(i)">{{ i }}</a>
                        </div>
                    </div>
                    {{ trans[locale].perPage }}
                </div>
            </div>
        </nav>

        <modal init_id="ListModal"
               :init_fields="{}"
               :init_title="modal_lang.ListModal ? modal_lang.ListModal.modalTitle : ''"
               ref="ListModal"
        >
            <template slot="body" slot-scope="body">
                <template v-if="modal_message != ''">
                    {{ modal_message }}
                </template>
                <template v-else>
                    {{ modal_lang.ListModal ? modal_lang.ListModal.modalMessage : ''}}
                </template>
            </template>
            <template slot="footer" slot-scope="footer">
                <div class="modal-footer">
                    <button type="button" class="btn btn-white" data-dismiss="modal">
                        {{ modal_lang.ListModal ? modal_lang.ListModal.modalCancel : '' }}
                    </button>
                    <button type="button" class="btn btn-blue" @click="deleteRecord">
                        {{ modal_lang.ListModal ? modal_lang.ListModal.modalSubmit : '' }}
                    </button>
                </div>
            </template>
        </modal>

        <slot name="modal_area" :row_checkbox="row_checkbox" :modalSubmit="modalSubmit"></slot>
    </div>
</template>
<script>
    import deleteModal from "../../mixins/deleteModal";
    import checkBoxInTable from "../../mixins/checkBoxInTable";

    export default {
        mixins: [deleteModal, checkBoxInTable],
        data() {
            return {
                table_data: this.init_data ? JSON.parse(this.init_data) : {},
                additional: this.init_additional,
                thead_class: this.init_thead_class,
                tbody_class: this.init_tbody_class,
                locale: window.locale,
                lang: {
                    en: {
                        display: 'Display',
                        page: 'Page',
                        perPage: 'Items/Page',
                    },
                    'zh-HK': {
                        display: '顯示',
                        page: '頁數',
                        perPage: '項/頁',
                    },
                    dev: {
                        display: 'table.vue.lang.display',
                        page: 'table.vue.lang.page',
                        perPage: 'table.vue.lang.perPage',
                    }
                },
                with_action_bar: false,
            }
        },
        props: {
            element_id: {
                required: false,
                type: String,
                default: null
            },
            url: {
                required: true,
                type: String,
            },
            responsive: {
                type: Boolean,
                default: true,
            },
            init_table_class: {
                type: String,
                default: 'table-style1 table-hover table-striped',
            },
            init_table_style: {
                type: String,
                default: '',
            },
            init_data: {
                default: null,
                required: false,
            },
            init_thead_class: {
                default: () => {
                    return [];
                },
            },
            init_tbody_class: {
                default: () => {
                    return [];
                },
            },
            extract_hook_success_callback: {
                type: Boolean,
                default: false,
            },
            extract_hook_fail_callback: {
                type: Boolean,
                default: false,
            },
            disable_filters: {
                type: Boolean,
                required: false,
                default: false,
            },
            table_page_id: {
                type: String,
                default: null,
                required: false
            }
        },
        beforeDestroy() {
			window.eventHub.$off('extract-table-data', (element_id) => {
                if (_.isUndefined(element_id) || element_id == this.element_id) {
                    return this.table_data;
                } else {
                    return '';
                }
            });
			window.eventHub.$off('list-reload-data', (element_id) => {
                if (_.isUndefined(element_id) || element_id == this.element_id) {
                    if (this.url.includes('?')) {
                        this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
                    } else {
                        this.fetchData(this.url + this.$store.getters.query);
                    }
                }
            });
        },
        mounted() {
            if (this.url.includes('?')) {
                this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
            } else {
                this.fetchData(this.url + this.$store.getters.query);
            }
			window.eventHub.$on('extract-table-data', (element_id) => {
                if (_.isUndefined(element_id)) {
                    window.eventHub.$emit('pull-table-data', this.table_data);
                } else {
                    if (element_id == this.element_id) {
                        window.eventHub.$emit('pull-table-data', this.table_data, element_id);
                    }
                }
            });
			window.eventHub.$on('list-reload-data', (element_id) => {
                if (_.isUndefined(element_id) || element_id == this.element_id) {
                    if (this.url.includes('?')) {
                        this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
                    } else {
                        this.fetchData(this.url + this.$store.getters.query);
                    }
                }
            });

			if (document.getElementsByClassName('table-actions').length > 0) {
                this.with_action_bar = true;
            }
        },
        methods: {
            fetchData(url) {
                let self = this;
                self.$store.commit('setSubmitting', true);
                self.select_all = false;

                let successCallback = (response) => {
                    self.table_data = response.data;
                    self.row_checkbox = [];
                    self.$store.commit('setSubmitting', false);
                    if (self.extract_hook_success_callback) {
                        if (_.isNull(this.element_id)) {
                            window.eventHub.$emit('extract-table-data');
                        } else {
                            window.eventHub.$emit('extract-table-data', self.element_id);
                        }
                    }
                    this.$nextTick(() =>{
                        if (document.getElementsByClassName('table-actions').length > 0) {
                            self.with_action_bar = true;
                        }
                    });
                };

                let failCallback = (error) => {
                    self.$store.commit('setNotificationType', 'danger');
                    self.$store.commit('setNotification', error.response.data.message);
                    self.$store.commit('setSubmitting', false);
                    if (self.extract_hook_fail_callback) {
                        if (_.isNull(this.element_id)) {
                            window.eventHub.$emit('extract-table-data');
                        } else {
                            window.eventHub.$emit('extract-table-data', self.element_id);
                        }
                    }
                }
                if (url != '') {
                    if(!_.isNil(this.editTablePageId) && this.$root.unique_page_id != null){
                        if (this.url.includes('?')) {
                            url = this.url + _.replace(this.$store.getters.query, '?', '&');
                        } else {
                            url = this.url + this.$store.getters.query;
                        }
                    }

                    this.$root.ajax_get(url, successCallback, failCallback);
                }
            },
            changePage(val) {
                this.$store.commit('setFilterPage', val);
            },
            changePerPage(val) {
                this.$store.commit('setFilterPerPage', val);
            },
            first() {
                this.changePage(1);
            },
            last() {
                this.changePage(this.meta.last_page);
            },
            next() {
                this.changePage(this.meta.current_page + 1);
            },
            previous() {
                this.changePage(this.meta.current_page - 1);
            },
            sort(field) {
                this.$store.commit('setFilterSort', field);
                this.$store.commit('toggleFilterOrder')
            },
            search(keyword) {
                this.$store.commit('setFilterKeyword', keyword);
            },
        },
        watch: {
            filter() {
                if (!this.disable_filters) {
                    if (this.url.includes('?')) {
                        this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
                    } else {
                        this.fetchData(this.url + this.$store.getters.query);
                    }
                }
            },
            url() {
                if (this.url != '') {
                    if (this.url.includes('?')) {
                        this.fetchData(this.url + _.replace(this.$store.getters.query, '?', '&'));
                    } else {
                        this.fetchData(this.url + this.$store.getters.query);
                    }
                }
            },
        },
        computed: {
            noOfRecords() {
                return this.table_data.data ? this.table_data.data.length : 0;
            },
            hasRecords() {
                return this.table_data.data ? this.table_data.data.length : false;
            },
            filter() {
                return this.$store.getters.query;
            },
            showing() {
                let str = this.table_data ? this.table_data.paginate : '';

                if (str)
                    return str.replace(':from', this.table_data.meta.from)
                        .replace(':total', this.table_data.meta.total)
                        .replace(':to', this.table_data.meta.to)
                        .replace(new RegExp('null', 'g'), 0);
            },
            hasPage() {
                if (!this.table_data.hasOwnProperty('meta')) return false;
                return this.table_data.meta.total > 0;
            },
            onFirstPage() {
                if (!this.table_data.hasOwnProperty('meta')) return false;
                return this.table_data.meta.current_page == 1;
            },
            hasMorePage() {
                if (!this.table_data.hasOwnProperty('meta')) return false;
                return this.table_data.meta.current_page < this.table_data.meta.last_page;
            },
            meta() {
                if (!this.table_data.hasOwnProperty('meta')) return {};
                return {
                    showing: this.showing,
                    hasMorePage: this.hasMorePage,
                    hasPage: this.hasPage,
                    onFirstPage: this.onFirstPage,
                    current_page: this.table_data.meta.current_page,
                    per_page: this.table_data.meta.per_page,
                    last_page: this.table_data.meta.last_page,
                    first_item: this.table_data.meta.from,
                }
            },
            editTablePageId() {
                if(this.table_page_id != null && this.table_page_id != ''){
                    this.$root.unique_page_id = this.table_page_id;
                    this.$store.state.unique_page_id = this.table_page_id;

                    if(_.isNil(this.$store.state.filters[this.table_page_id + '_page'])){
                        Vue.set(this.$store.state.filters, (this.table_page_id + '_page'), 1);
                    }
                    if(_.isNil(this.$store.state.filters[this.table_page_id + '_per_page'])) {
                        Vue.set(this.$store.state.filters, (this.table_page_id + '_per_page'), 10);
                    }
                    return this.table_page_id;
                }
                else{
                    this.$root.unique_page_id = '';
                    this.$store.state.unique_page_id = '';

                    return '';
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Table/Table.vue